/*
get-locale.service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/services/get-locale.service',[
    '../module',
    './system-language.service'
], function (module, systemLanguageService) {
    'use strict';

    module.service('getLocaleService', ['ShellUserService', '$q', function (shellUserService, $q) {
        var getLocale = function () {
            return systemLanguageService.getSystemLanguage();
        };

        var isUserLanguageRTL = function() {
            var browserLanguage = systemLanguageService.browserLanguage();
            return browserLanguage === "he" || browserLanguage === "he-IL";
        };

        var isApplicationLanguageRTL = function() {
            return getLocale() === "he";
        };

        this.getLocale = getLocale;
        this.isUserLanguageRTL = isUserLanguageRTL;
        this.isApplicationLanguageRTL = isApplicationLanguageRTL;

        var COMPLETE_RTL_SUPPORT = "FULL";
        var RTL_INPUTS_ONLY = "RTL-INPUTS-ONLY";
        var NO_RTL = "";

        /**
         * Returns RTL support required or not prior to user authentication.
         * @returns
         * Empty string if browser language is non-RTL.
         * "FULL" if browser language is RTL.
         */
        var getRTLPolicyForUnauthenitcatedSrceens = function() {
            return isUserLanguageRTL() ? COMPLETE_RTL_SUPPORT : NO_RTL;
        };

        /**
         * Return degree of RTL support to be provided when user is authenticated.
         * @returns
         * Empty string if browser language is non-RTL.
         * "FULL" if broswer language is RTL and user is patient
         * "RTL-INPUTS-ONLY" if browser language is RTL and user is not patient (ie HP)
         */
        var getRTLPolicyForAuthenitcatedSrceens = function(user) {
            return isUserLanguageRTL() ?
            (user.isPatient ? COMPLETE_RTL_SUPPORT : RTL_INPUTS_ONLY)
            : NO_RTL;
        };

        this.rtlSupport = function() {
            var deferred = $q.defer();

            shellUserService.getUserData()
            .then(function(user) {
                deferred.resolve(getRTLPolicyForAuthenitcatedSrceens(user));
            }, function() {
                deferred.resolve(getRTLPolicyForUnauthenitcatedSrceens());
            });

            return deferred.promise;
        };
    }]);
});

